type ClassNameTypes = string | null | false | undefined | boolean;

/**
 * Combines class names into a single string, filtering out falsy values
 * @param classNamesInput - Array of class names or multiple string arguments
 * @returns Combined class names as a string
 */
export const cnLite = (
  ...classNamesInput: ClassNameTypes[] | [ClassNameTypes[]]
) => {
  const classNames = Array.isArray(classNamesInput[0])
    ? classNamesInput[0]
    : classNamesInput;

  return classNames.filter(Boolean).join(' ');
};
